import 'jquery.easing'
import 'svgxuse'
import 'bootstrap'
import INIT from './module/init'
import HOME from './page/home'
import CUISINE from './page/cuisine'
import SHOP from './page/shop'
import FORM from './module/form'

const [ w, d, l ] = [ window, document, location ]

INIT()

switch(l.pathname.replace(/^(\/[^./]+\/)[^.]+\.?(:?php|html)?/,'$1')){
  case '/': HOME(); break
  case '/cuisine/': CUISINE(); break
  case '/shop/': SHOP(); break

  case '/contact/':
  case '/order/': FORM(); break
}